import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelector('.hero')){
    const headerHeight = document.querySelector('header.header').clientHeight;

    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".hero__img img", {
      scrollTrigger: {
        trigger: ".hero",
        once: false,
        scrub: true,
        markers: false,
        start: "top "+headerHeight,
        end: "bottom-=30% top",
    },
    y: '40%'
    });
  }
});

